var React = require('react');

function Evening (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M54.5133 57H8.57556C3.85333 57 0 53.1925 0 48.4425C0 43.2024 4.68444 39.0933 10.0489 40.0357C8.95333 32.5337 14.7711 25.8611 22.2889 25.8611C28.9756 25.8611 34.3778 31.1389 34.6422 37.6984C37.06 35.8512 40.1578 35.2857 43.0289 36.002C47.6 37.1329 50.9244 41.4683 50.4711 46.5198C53.1911 44.1071 57.4222 44.6349 59.4622 47.6131C62.1822 51.5714 59.3489 57 54.5133 57Z","fill":"#DCE7EF","key":0}),React.createElement("path",{"d":"M63.618 28.5377C63.618 35.2857 60.4069 41.2798 55.458 45.0873C53.758 44.8234 51.9069 45.2758 50.5091 46.5199C51.0002 41.4683 47.638 37.1329 43.0669 36.002C49.1869 26.8036 46.3158 14.0992 36.3047 8.59524C49.8291 4.33532 63.618 14.4008 63.618 28.5377Z","fill":"#667778","key":1})]);
}

Evening.defaultProps = {"width":"68","height":"57","viewBox":"0 0 68 57","fill":"none"};

module.exports = Evening;

Evening.default = Evening;
